import Vue from 'vue'

export default new Vue()



// WEBPACK FOOTER //
// ./packages/utils/eventHub.js